export { Model } from './interfaces.d'
export { AllAdvicesComponent } from './all-advices/all-advices.component'
export { SingleAdviceComponent } from './single-advice/single-advice.component'
export { allAdvicesRoute, singleAdviceRoute } from "./constants";
export { AdvicesModule } from "./advices.module";